<app-tutor-menu>
  <nb-card>
    <nb-card-header>
      <h4>{{ 'pages.dozenten.linkedTutors' | translate }}</h4>
    </nb-card-header>
    <nb-card-body>
      <!-- The linked-tutors management + request flow lives in the shared
           twin-linked-tutors component. It decides admin vs. rights-limited
           mode via AuthService.isClientWide(): admins attach/detach
           directly, a role='user' dozent submits a link request that an
           admin approves from the bell. -->
      <app-twin-linked-tutors
        [dozentBotId]="dozentBotId"
      ></app-twin-linked-tutors>
    </nb-card-body>
  </nb-card>
</app-tutor-menu>
